import { usePhotoUrl } from "../features/checkins/api";
import { cn } from "../lib/cn";

/** The Pact pastel accent from the design handoff. */
export const GRADIENT =
  "linear-gradient(135deg, oklch(0.84 0.08 240), oklch(0.86 0.08 195), oklch(0.87 0.1 155))";

/**
 * A person's avatar: their photo if they have one, otherwise their initial,
 * inside the pastel gradient ring (pass `ring={0}` for no ring).
 */
export function ProfileAvatar({
  name,
  avatarPath,
  size,
  ring = 3,
  className,
}: {
  name: string;
  avatarPath?: string | null;
  size: number;
  ring?: number;
  className?: string;
}) {
  const photo = usePhotoUrl(avatarPath);

  return (
    <span
      className={cn("inline-block shrink-0 rounded-full", className)}
      style={{ width: size, height: size, padding: ring, background: ring ? GRADIENT : "transparent" }}
    >
      <span
        className={cn(
          "flex size-full items-center justify-center overflow-hidden rounded-full font-semibold",
          ring ? "bg-white" : "bg-[#f3f3f5]",
        )}
        style={{ fontSize: Math.round(size * 0.34) }}
      >
        {photo.data ? (
          <img src={photo.data} alt="" className="size-full object-cover" />
        ) : (
          name.charAt(0).toUpperCase()
        )}
      </span>
    </span>
  );
}
